import { iIconProps } from '../../icon';

export default function YouTubeIcon({ size, ...props }: iIconProps): JSX.Element {
    return (
        <svg width={size} height={size} viewBox='0 0 24 24' {...props}>
            <path
                d='M21.58 7.19c-.11-.42-.34-.81-.65-1.12s-.7-.53-1.12-.65c-1.56-.43-7.82-.43-7.82-.43s-6.26 0-7.81.42c-.42.11-.81.34-1.12.65s-.53.7-.65 1.13c-.42 1.56-.42 4.82-.42 4.82s0 3.26.42 4.82c.11.42.34.81.65 1.12s.7.53 1.12.65c1.56.42 7.81.42 7.81.42s6.26 0 7.82-.42c.42-.11.81-.34 1.12-.65s.53-.7.65-1.12c.42-1.56.42-4.82.42-4.82s0-3.26-.42-4.82M10 15.01v-6l5.2 3z'
                fill='currentColor'
            />
        </svg>
    );
}
